export const ENTERPRISE_PPP_III = 'enterprise-ppp-iii'
export const CLOVER_DFA_ENABLED = 'clover-dfa-enabled'
export const ENTERPRISE_DASHBOARD_TOP_CTA = 'enterprise-dashboard-top-cta'
export const SHOULD_UN_GATE_FUNDING_APPLICATION = 'should-un-gate-funding-application'
export const PPP_FUNDS_EXHAUSTED = 'ppp-funds-exhausted'
/**
 * OPTION_ELIGIBILITY_ESTIMATE_BUCKET_ENABLED controls whether or not we show the option eligibility estimate bucket on the marketplace
 * instead of the match factor score.
 *
 * safe to remove: once rollout is at 100%
 */
export const OPTION_ELIGIBILITY_ESTIMATE_BUCKET_ENABLED = 'ent-web-option-eligibility-estimate-bucket-enabled'

/**
 * NO_MATCHFACTOR_NO_APPLY
 *
 * safe to remove: TODO
 */
export const NO_MATCHFACTOR_NO_APPLY = 'no-matchfactor-no-apply'

/**
 * USE_ML_CC_APPROVAL_ODDS controls whether or not we will use the machine learning model to determine eligibility for a user response
 *
 * safe to remove: once rollout is at 100%
 */
export const USE_ML_CC_APPROVAL_ODDS = 'use-ml-cc-approval-odds'

/**
 * USE_ML_CC_APPROVAL_ODDS_RESTRICTED controls whether or not we will use the machine learning model to determine eligibility for a user response in the second cohort,
 * excluding approval odds scores <= 25 for this cohort only.
 *
 * safe to remove: once rollout is at 100%
 */
export const USE_ML_CC_APPROVAL_ODDS_RESTRICTED = 'use-approval-odds-restricted'
